const primary = '#00218D';
const background = '#F4F6FC';
const link = '#0000EE';
const green = '#008000';
const yellow = '#FFFF00';
const red = '#FF0000';
const blue = '#0000FF';
const orange = '#FFA500';
const orange10 = '#FF9D54';
const orange11 = '#FFEBDC';
const grey = '#B2B3B7';
const red2 = '#FC2C32';

// Secondary Colors
const secondaryPink1 = '#E6B3FF';
const secondaryPink2 = '#F5E1FF';
const secondaryPink3 = '#FAF0FF';

const secondaryPeach1 = '#FCA19C';
const secondaryPeach2 = '#FED9D7';
const secondaryPeach3 = '#FEECEB';
const secondaryPeach4 = '#f47d93';
const secondaryPeach5 = '#FFDCCD';
const secondaryPeach6 = '#E96029';

const secondaryYellow1 = '#FFE55B';
const secondaryYellow2 = '#FFF5BD';
const secondaryYellow3 = '#FFFADE';

const secondaryGreen1 = '#CEE75C';
const secondaryGreen2 = '#E3F496';
const secondaryGreen3 = '#F5FADE';

const secondaryPrime = '#9CD2FF';

//  Neutral Colors
const neutral900 = '#061938';
const neutral700 = '#253858';
const neutral400 = '#505F79';
const neutral103 = '#465881';
const neutral102 = '#adb6c9';
const neutral101 = '#5d6d91';
const neutral100 = '#7A869A';
const neutral61 = '#8693B0';
const neutral60 = '#B3BAC5';
const neutral41 = '#DFE8FF';
const neutral40 = '#DFE1E6';
const neutral20 = '#F4F5F7';
const neutral7 = '#F9F9FB';
const neutral9 = '#F9F9F9';
const neutral10 = '#FAFBFC';
const neutral11 = '#f6f7fa';
const neutral12 = '#b1b9cc';
const neutral13 = '#F9FAFF';
const neutral8 = 'rgba(0, 0, 0, 0.04)';
const neural500 = '#E0E0E9';

// Tertiary Colors
const tertiaryRed503 = '#EF4060';
const tertiaryRed502 = '#F2564A';
const tertiaryRed501 = '#F14B2D';
const tertiaryRed500 = '#B92500';
const tertiaryRed400 = '#DE350B';
const tertiaryRed300 = '#FF5630';
const tertiaryRed200 = '#FF7452';
const tertiaryRed100 = '#FF8F73';
const tertiaryRed75 = '#FFBDAD';
const tertiaryRed50 = '#FFEBE6';

const tertiaryYellow502 = '#b59353';
const tertiaryYellow501 = '#be9f64';
const tertiaryYellow500 = '#FF8B00';
const tertiaryYellow400 = '#FF991F';
const tertiaryYellow300 = '#FFAB00';
const tertiaryYellow200 = '#FFC400';
const tertiaryYellow100 = '#FFE380';
const tertiaryYellow75 = '#FFF0B3';
const tertiaryYellow74 = '#FDEECF';
const tertiaryYellow50 = '#FFFAE6';

const tertiaryGreen504 = '#52C15A';
const tertiaryGreen503 = '#658e6d';
const tertiaryGreen502 = '#80d185';
const tertiaryGreen501 = '#D0FAEE';
const tertiaryGreen500 = '#006644';
const tertiaryGreen400 = '#00875A';
const tertiaryGreen300 = '#36B37E';
const tertiaryGreen200 = '#57D9A3';
const tertiaryGreen100 = '#79F2C0';
const tertiaryGreen75 = '#ABF5D1';
const tertiaryGreen50 = '#E3FCEF';
const tertiaryGreen49 = '#C8ECE3';
const tertiaryGreen48 = '#35714D';
const tertiaryGreen47 = '#CCE9E4';
const tertiaryGreen = '#00B25D';

const tertiaryTeal502 = '#8693B0';
const tertiaryTeal501 = '#5A9EBF';
const tertiaryTeal500 = '#008DA6';
const tertiaryTeal400 = '#00A3BF';
const tertiaryTeal300 = '#00B8D9';
const tertiaryTeal200 = '#00C7E6';
const tertiaryTeal199 = '#86D7FA';
const tertiaryTeal198 = '#CFEFFD';
const tertiaryTeal100 = '#79E2F2';
const tertiaryTeal75 = '#B3F5FF';
const tertiaryTeal50 = '#E6FCFF';

const tertiaryBlue505 = '#002E9E';
const tertiaryBlue504 = '#465881';
const tertiaryBlue503 = '#051648';
const tertiaryBlue502 = '#02195E';
const tertiaryBlue501 = '#00218D';
const tertiaryBlue500 = '#0747A6';
const tertiaryBlue400 = '#0052CC';
const tertiaryBlue300 = '#0065FF';
const tertiaryBlue200 = '#2684FF';
const tertiaryBlue100 = '#4C9AFF';
const tertiaryBlue99 = '#0077FF';

const tertiaryBlue80 = '#677FCA';
const tertiaryBlue75 = '#B3D4FF';
const tertiaryBlue50 = '#DEEBFF';
const tertiaryBlue40 = '#FBFCFE';

const tertiaryPurple501 = '#4259AF';
const tertiaryPurple500 = '#403294';
const tertiaryPurple400 = '#5243AA';
const tertiaryPurple300 = '#6554C0';
const tertiaryPurple201 = '#997AFF';
const tertiaryPurple200 = '#8777D9';
const tertiaryPurple100 = '#998DD9';
const tertiaryPurple75 = '#C0B6F2';
const tertiaryPurple70 = '#D9E1FF';
const tertiaryPurple51 = '#E1D8FF';
const tertiaryPurple50 = '#EAE6FF';

const assessmentBorder = '#E3E3E3';
const shadowColor = '#D6E0FF';
const lightGray10 = '#F7F8F9';
const kenWhite = '#ffffff';
const kenBlack = '#000000';

const tertiaryGray50 = '#999999';
const lightGray = '#CCCCCC';
const scrollbarColor = '#a3a6b6';

const sideNavBackground = '#787878';
const sideNavColor = '#FFF';
const sideNavItemActiveBackground = '#000000';
const sideNavItemActiveColor = '#FFF';
const sideNavItemHoverBackground = '#000000';
const sideNavItemHoverColor = '#FFF';

const kpiBackground = '#2b3844';
const avatarBackground = '#EFA548';

const headerBackground = kenWhite;

const cardActiveBackground = '#F9F3EB';
const cardActiveColor = '#000';
const cardActiveBorderColor = '#2C60AA';

const switchActiveBackground = '#3E67FF';

const searchBackground = '#F2F5FA';
//grade marks:
const a1BgColor = '#CCF1D7';
const a1FontColor = '#00BA35';
const a2BgColor = '#DDF1D5';
const a2FontColor = '#65BF43';
const b1BgColor = '#EDF2D3';
const b1FontColor = '#A6BC22';
const b2BgColor = '#EDF5DC';
const b2FontColor = '#A6CF4F';
const c1BgColor = '#FEF2D1';
const c1FontColor = '#F9BD19';
const c2BgColor = '#FDEAD2';
const c2FontColor = '#F69720';
const gradeDBgColor = '#FDE3D4';
const gradeDFontColor = '#F47126';
const gradeEBgColor = '#FCDBD5';
const gradeEFontColor = '#F14B2D';
const backgroundSideNav = '#EDEFF1';

const gradeSectionHeaderLabel = '#2C60AA';
const gradeTermLabel = '#02195E';
const gradeSectionBorder = '#D7DEE9';
const gradeSectionSubjectBg = '#F8F9FB';
const classesListBorderColor = '#E1DDDD';
const subjectSectionLabel = '#3D58AE';
const customizeScrollTrack = '#E5E7EB';
const borderColor = '#0062cc';
const eventBorderColor = '#005cbf';

const flagIconColor = '#ABAFBC';
const flagIconBorderColor = '#DFE1E6';

const secondaryBlue = '#DFE8FF';
const grey5 = '#B3BAC5';
const grey4 = '#A8AFBC';
const grey3 = '#7A869A';
const grey2 = '#505F79';

const darkGreen = '#158467';

const dark = '#061938';

const innerBorder = '#E3E3E3';

const card = '#F7F8FB';
const card1 = '#E9EFFF';

const statusRed = '#E75547';
const statusYellow = '#F6C445';
const statusGreen = '#1BBE75';

const vibrantBlue = '#2862FF';

// Client Colors

const ClientMenuApp: string = '#2C60AA';
const ClientSide: string = '#2C60AA';
const clientSideNavMenu: string = '#08466F';
const clientKenCard: string = '#193890fa';
const clientKenInputBorder: string = '#08466F';
const clientComponents: string = '#08466F';
const clientCLight: string = '#505F79';
const clientCLightBackground: string = '#F8F8F8';
const clientDark: string = '#84A5FF1A';
const clientComponentsLight: string = '#F8FBFF';
const clientComponentsBorder: string = '#E4E4E4';
const clientComponentsBorderLight: string = '#D2E1E9';
const clientKenInputbackgroundColor: string = '#FAFBFC';
const clientKenInputBorderVisited: string = '#57D9A3';
const clientBlackBackground: string = '#000000';
const clientKenSelectMenu: string = '#DE350B';
const clientSidecssUserName: string = '#3f4a59';
const clientGraphColor1: string = '#11263C';
const clientGraphColor2: string = '#D0EED2';
const clientGraphColor3: string = '#FFFBEB';
const clientGraphColor4: string = '#FFB042';
const clientGraphColor5: string = '#F6CEC9';
const clientGraphLabelColor: string = '#565353';
const clientGraphValueColor: string = '#263238';
const clientError: string = '#FF0000';
const clientAccept: string = '#52C15A45';
const clientPending: string = '#FFEFB645';
const clientRejected: string = '#DD4B3945';
const clientCardLightGrey: string = '#959595';
const clientDarkGrey: string = '#7A7A7B';
const clientColor: string = '#2C60AA';
const clientBorder: string = '#d1d1d1';
const ClientBlack: string = '#585A64';
const ClientBlack1: string = '#333333';
const ClientBlack2: string = '#373A45';
const ClientPrimary: string = '#2C60AA';
const ClientPrimaryGradientI: string = 'linear-gradient(90deg, #00387A -30.21%, #006BB7 100%);';
const ClientPrimaryGradientII: string = 'linear-gradient(0deg, #4C21D9, #4C21D9), linear-gradient(180deg, #6132FF 0%, #321594 100%),#2C60AA';
const ClientPrimaryII: string = '#2C60AA';
const ClientRed3: string = '#EBF4EC';
const ClientBlue: string = '#2C60AA';
const ClientDivider: string = '#E5E6EA';
const ClientPrimaryGrey: string = '#E8EBF3';
const ClientGraphBlue: string = '#07588f';
const ClientGrey: string = '#8C8E94';
const ClientGrey2: string = '#F6F8FB';
const ClientGrey3: string = '#E6E6E8';
const ClientBlue2: string = '#193389';
const ClientBlue3: string = '#5981FF';
const ClientBlue4: string = '#BFCEFF';
const ClientBlue5: string = '#1A358C';
const ClientBlue6: string = '#2C58E8';
const ClientBlue7: string = '#3061FF';
const ClientBlue8: string = '#C6C9D2';
const ClientWhite: string = '#E0E0E0';
const ClientShadow: string = 'rgba(131, 119, 198, 0.11)';
const ClientLogin: string = 'rgba(255, 255, 255, 0.9)';
const ClientRed: string = '#962121';
const ClientRed2: string = '#FBEAEA';

const KenColors = {
  ClientBlue,
  ClientPrimaryGradientI,
  ClientPrimaryGradientII,
  ClientBlack,
  ClientBlack1,
  ClientRed2,
  ClientRed3,
  ClientPrimaryII,
  ClientGraphBlue,
  ClientRed,
  ClientLogin,
  ClientGrey2,
  ClientGrey3,
  ClientBlue8,
  ClientBlue7,
  ClientWhite,
  ClientBlue6,
  ClientBlue4,
  ClientBlue5,
  ClientBlue3,
  ClientBlue2,
  ClientGrey,
  ClientShadow,
  ClientBlack2,
  ClientPrimaryGrey,
  ClientPrimary,
  ClientDivider,
  clientBlackBackground,
  clientBorder,
  clientColor,
  clientDarkGrey,
  clientCardLightGrey,
  clientRejected,
  clientPending,
  clientAccept,
  clientCLightBackground,
  clientError,
  clientDark,
  clientGraphValueColor,
  clientComponentsBorderLight,
  clientGraphLabelColor,
  clientGraphColor5,
  clientGraphColor4,
  clientGraphColor3,
  clientGraphColor2,
  clientGraphColor1,
  clientCLight,
  clientComponentsLight,
  clientComponentsBorder,
  clientComponents,
  clientSidecssUserName,
  clientKenSelectMenu,
  clientKenInputBorderVisited,
  clientKenInputbackgroundColor,
  clientSideNavMenu,
  clientKenInputBorder,
  clientKenCard,
  ClientSide,
  ClientMenuApp,
  primary,
  background,
  green,
  yellow,
  red,
  blue,
  orange,
  orange10,
  orange11,
  avatarBackground,
  scrollbarColor,
  secondaryPink1,
  secondaryPink2,
  secondaryPink3,
  secondaryPeach1,
  secondaryPeach2,
  secondaryPeach3,
  secondaryPeach4,
  secondaryPeach5,
  secondaryPeach6,
  secondaryYellow1,
  secondaryYellow2,
  secondaryYellow3,
  secondaryGreen1,
  secondaryGreen2,
  secondaryGreen3,
  secondaryPrime,
  neutral900,
  neutral700,
  neutral400,
  neutral103,
  neutral102,
  neutral101,
  neutral100,
  neutral61,
  neutral60,
  neutral41,
  neutral40,
  neutral20,
  neutral13,
  neutral12,
  neutral11,
  neutral10,
  neutral9,
  neutral8,
  neutral7,
  tertiaryRed503,
  tertiaryRed502,
  tertiaryRed501,
  tertiaryRed500,
  tertiaryRed400,
  tertiaryRed300,
  tertiaryRed200,
  tertiaryRed100,
  tertiaryRed75,
  tertiaryRed50,
  tertiaryYellow502,
  tertiaryYellow501,
  tertiaryYellow500,
  tertiaryYellow400,
  tertiaryYellow300,
  tertiaryYellow200,
  tertiaryYellow100,
  tertiaryYellow75,
  tertiaryYellow74,
  tertiaryYellow50,
  tertiaryGreen504,
  tertiaryGreen503,
  tertiaryGreen502,
  tertiaryGreen501,
  tertiaryGreen500,
  tertiaryGreen400,
  tertiaryGreen300,
  tertiaryGreen200,
  tertiaryGreen100,
  tertiaryGreen75,
  tertiaryGreen50,
  tertiaryGreen49,
  tertiaryGreen48,
  tertiaryGreen47,
  tertiaryGreen,
  tertiaryBlue503,
  tertiaryTeal502,
  tertiaryTeal501,
  tertiaryTeal500,
  tertiaryTeal400,
  tertiaryTeal300,
  tertiaryTeal200,
  tertiaryTeal199,
  tertiaryTeal198,
  tertiaryTeal100,
  tertiaryTeal75,
  tertiaryTeal50,
  tertiaryBlue505,
  tertiaryBlue504,
  tertiaryBlue502,
  tertiaryBlue501,
  tertiaryBlue500,
  tertiaryBlue400,
  tertiaryBlue300,
  tertiaryBlue200,
  link,
  tertiaryBlue100,
  tertiaryBlue99,
  tertiaryBlue80,
  tertiaryBlue75,
  tertiaryBlue50,
  tertiaryBlue40,
  tertiaryPurple501,
  tertiaryPurple500,
  tertiaryPurple400,
  tertiaryPurple300,
  tertiaryPurple201,
  tertiaryPurple200,
  tertiaryPurple100,
  tertiaryPurple75,
  tertiaryPurple70,
  tertiaryPurple51,
  tertiaryPurple50,
  lightGray10,
  shadowColor,
  kenWhite,
  assessmentBorder,
  kenBlack,
  sideNavBackground,
  sideNavColor,
  sideNavItemActiveBackground,
  sideNavItemActiveColor,
  sideNavItemHoverBackground,
  sideNavItemHoverColor,
  headerBackground,
  cardActiveBackground,
  cardActiveColor,
  kpiBackground,
  cardActiveBorderColor,
  a1BgColor,
  a1FontColor,
  a2BgColor,
  a2FontColor,
  b1BgColor,
  b1FontColor,
  b2BgColor,
  b2FontColor,
  c1BgColor,
  c1FontColor,
  c2BgColor,
  c2FontColor,
  gradeDBgColor,
  gradeDFontColor,
  gradeEBgColor,
  gradeEFontColor,
  gradeSectionHeaderLabel,
  gradeSectionBorder,
  gradeTermLabel,
  gradeSectionSubjectBg,
  switchActiveBackground,
  classesListBorderColor,
  subjectSectionLabel,
  tertiaryGray50,
  customizeScrollTrack,
  searchBackground,
  lightGray,
  borderColor,
  eventBorderColor,
  flagIconColor,
  flagIconBorderColor,
  secondaryBlue,
  backgroundSideNav,
  grey5,
  grey4,
  grey3,
  grey2,
  innerBorder,
  dark,
  darkGreen,
  card,
  card1,
  statusRed,
  statusYellow,
  statusGreen,
  vibrantBlue,
  grey,
  neural500,
  red2,
};

Object.entries(KenColors).forEach(([name, value]) => {
  document.documentElement.style.setProperty(`--${name}`, value);
});
export default KenColors;
